const skills = [
{
    src: "./logos/html5.png",
    alt: "html-logo",   
    position: "odd",
},
{
    src: "./logos/css.png",
    alt: "css-logo",   
    position: "even",
},
{
    src: "./logos/javascript.png",
    alt: "javascript-logo",   
    position: "odd",
},
{
    src: "./logos/react.png",
    alt: "react-logo",   
    position: "even",
},
{
    src: "./logos/node-js.png",
    alt: "node-logo",   
    position: "odd",
},
{
    src: "./logos/express.png",
    alt: "express-logo",   
    position: "even",
},
{
    src: "./logos/mongodb.png",
    alt: "mongodb-logo",   
    position: "odd",
},
{
    src: "./logos/mongoose.png",
    alt: "mongoose-logo",   
    position: "even",
},
];

export default skills;